/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowCUpIcon16Light } from './ArrowCUpIcon16Light';
import { ArrowCUpIcon16Regular } from './ArrowCUpIcon16Regular';
import { ArrowCUpIcon16Solid } from './ArrowCUpIcon16Solid';
import { ArrowCUpIcon20Light } from './ArrowCUpIcon20Light';
import { ArrowCUpIcon20Regular } from './ArrowCUpIcon20Regular';
import { ArrowCUpIcon20Solid } from './ArrowCUpIcon20Solid';
import { ArrowCUpIcon24Regular } from './ArrowCUpIcon24Regular';
import { ArrowCUpIcon24Solid } from './ArrowCUpIcon24Solid';
import { ArrowCUpIcon32Regular } from './ArrowCUpIcon32Regular';
import { ArrowCUpIcon64Regular } from './ArrowCUpIcon64Regular';
var sizes = {
    16: {
        light: ArrowCUpIcon16Light,
        regular: ArrowCUpIcon16Regular,
        solid: ArrowCUpIcon16Solid,
    },
    20: {
        light: ArrowCUpIcon20Light,
        regular: ArrowCUpIcon20Regular,
        solid: ArrowCUpIcon20Solid,
    },
    24: {
        regular: ArrowCUpIcon24Regular,
        solid: ArrowCUpIcon24Solid,
    },
    32: {
        regular: ArrowCUpIcon32Regular,
    },
    64: {
        regular: ArrowCUpIcon64Regular,
    },
};
export var ArrowCUpIcon = forwardRef('ArrowCUpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
